var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 27,
    viewBox: "0 0 29 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3333 17.8125L18.9583 13.5M18.9583 13.5L14.3333 9.1875M18.9583 13.5H2M9.70833 6.66985V6.60029C9.70833 4.99013 9.70833 4.18445 10.0444 3.56946C10.34 3.02849 10.8113 2.58899 11.3915 2.31336C12.051 2 12.9152 2 14.642 2H21.7336C23.4605 2 24.3227 2 24.9822 2.31336C25.5624 2.58899 26.0354 3.02849 26.3309 3.56946C26.6667 4.18385 26.6667 4.98855 26.6667 6.59556V20.4052C26.6667 22.0122 26.6667 22.8157 26.3309 23.4301C26.0354 23.971 25.5624 24.4113 24.9822 24.6869C24.3233 25 23.4615 25 21.7381 25H14.6369C12.9135 25 12.0504 25 11.3915 24.6869C10.8113 24.4113 10.34 23.9706 10.0444 23.4297C9.70833 22.8147 9.70833 22.0101 9.70833 20.4V20.3281",
    stroke: "#292929",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.65eec597184bd33ec788bf052ca4be2d.svg";
export { ForwardRef as ReactComponent };